import type {ValueOf} from '~/types/value-of'

export const IFeaturedType = {
  NEW: 'NEW',
} as const
export type IFeaturedType = ValueOf<typeof IFeaturedType>

export const IFeaturedMenuKey = {
  SIDEBAR: 'SIDEBAR',
} as const
export type IFeaturedMenuKey = ValueOf<typeof IFeaturedMenuKey>